var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

var SafeAnchor = (_temp2 = _class = function (_React$Component) {
  _inherits(SafeAnchor, _React$Component);

  function SafeAnchor() {
    var _temp, _this, _ret;

    _classCallCheck(this, SafeAnchor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          href = _this$props.href,
          onClick = _this$props.onClick;


      if (disabled || isTrivialHref(href)) {
        e.preventDefault();
      }

      if (disabled) {
        e.stopPropagation();
        return;
      }

      if (onClick) {
        onClick(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SafeAnchor.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        disabled = _props.disabled,
        other = _objectWithoutProperties(_props, ['children', 'className', 'disabled']);

    if (disabled) {
      other.tabIndex = -1;
      other.style = _extends({ pointerEvents: 'none' }, other.style);
    }

    var anchorClass = classNames(className, {
      disabled: disabled
    });

    return React.createElement(
      'a',
      _extends({ className: anchorClass, onClick: this.handleClick, rel: 'noopener noreferrer' }, other),
      children
    );
  };

  return SafeAnchor;
}(React.Component), _class.defaultProps = {
  disabled: false,
  href: '#',
  role: 'button'
}, _temp2);
export { SafeAnchor as default };
SafeAnchor.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  role: PropTypes.string,
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};